// One reading of "what kind of file is this", derived from the name.
//
// Extraction derives the MIME type from the stored URL's extension server-side
// (FileService.getFileType), so the client must classify the same way or a page
// renders as one thing and extracts as another.
export const getFileType = (name = '') => {
  const lower = name.toLowerCase();
  if (lower.endsWith('.pdf')) return 'pdf';
  if (/\.(jpe?g|png|heic|heif|gif|webp)$/.test(lower)) return 'image';
  return 'word';
};
